import { operacoesPendentes, type OperacaoPendente } from './operacoes';

let operacoesData = [...operacoesPendentes];

export function getOperacoes(): OperacaoPendente[] {
  return operacoesData;
}

export function getOperacaoById(id: string): OperacaoPendente | undefined {
  return operacoesData.find(o => o.id === id);
}

export function aprovarOperacao(id: string, aprovador: string): boolean {
  const idx = operacoesData.findIndex(o => o.id === id);
  if (idx === -1) return false;
  operacoesData[idx] = {
    ...operacoesData[idx],
    status: 'aprovado',
    aprovado_por: aprovador,
    data_aprovacao: new Date().toISOString(),
  };
  return true;
}

export function rejeitarOperacao(id: string, aprovador: string, motivo: string): boolean {
  const idx = operacoesData.findIndex(o => o.id === id);
  if (idx === -1) return false;
  operacoesData[idx] = {
    ...operacoesData[idx],
    status: 'rejeitado',
    aprovado_por: aprovador,
    data_aprovacao: new Date().toISOString(),
    motivo_rejeicao: motivo,
  };
  return true;
}

export function criarOperacaoManual(operacao: Omit<OperacaoPendente, 'id' | 'status' | 'data_solicitacao'>): OperacaoPendente {
  const nova: OperacaoPendente = {
    id: `OP-${Date.now()}`,
    ...operacao,
    status: 'pendente',
    data_solicitacao: new Date().toISOString(),
  };
  operacoesData = [nova, ...operacoesData];
  return nova;
}